import { render, staticRenderFns } from "./CompareStatComponent.vue?vue&type=template&id=429ea85a&"
import script from "./CompareStatComponent.vue?vue&type=script&lang=js&"
export * from "./CompareStatComponent.vue?vue&type=script&lang=js&"
import style0 from "./CompareStatComponent.vue?vue&type=style&index=0&id=429ea85a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports